"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _actionHandler = _interopRequireDefault(require("../action-handler"));
var _utils = require("../../utils/utils");
var _urlSafety = require("../../utils/url-safety");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BwALoaderRenderHandler = exports["default"] = /*#__PURE__*/function (_ActionHandler) {
  function BwALoaderRenderHandler() {
    var _this;
    (0, _classCallCheck2["default"])(this, BwALoaderRenderHandler);
    _this = _callSuper(this, BwALoaderRenderHandler);
    _this.pre.push(function () {});
    return _this;
  }
  (0, _inherits2["default"])(BwALoaderRenderHandler, _ActionHandler);
  return (0, _createClass2["default"])(BwALoaderRenderHandler, [{
    key: "execute",
    value: function () {
      var _execute = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.render();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.injectBwALoader();
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "injectBwALoader",
    value: function injectBwALoader() {
      //@TODO: Check if we can move this loader HTML to an iframe.
      if ((0, _utils.safeGetElementById)('bwa-overlay') || (0, _utils.safeGetElementById)('bwa-loader')) return;
      var overlay = document.createElement('div');
      overlay.id = 'bwa-overlay';
      overlay.className = 'bwa-overlay';
      var loader = document.createElement('div');
      loader.id = 'bwa-loader';
      loader.className = 'bwa-loader';
      loader.innerHTML = '<div class="bwa-loader__title">Pre-filling your address</div>' + '<div class="bwa-loader__subtitle">This will only take a few seconds</div>' + '<div class="bwa-bubble-rail" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuetext="In progress">' + '<span class="bwa-bubble"></span>' + '<span class="bwa-bubble"></span>' + '<span class="bwa-bubble"></span>' + '</div>';
      document.body.appendChild(overlay);
      document.body.appendChild(loader);
      setTimeout(function () {
        overlay.classList.add('is-active');
        loader.classList.add('is-active');
        document.body.classList.add('bwa-no-scroll');
      }, 10);
    }
  }, {
    key: "updateLoaderForMeta",
    value: function updateLoaderForMeta(isSuccess, targetUrl) {
      var loader = (0, _utils.safeGetElementById)('bwa-loader');
      if (loader) {
        var message = isSuccess ? 'Address auto-filled successfully!' : 'Click to continue';
        loader.innerHTML = "<div class=\"bwa-loader__title\">".concat(message, "</div>") + '<button id="bwa-continue-btn" class="bwa-continue-btn">Continue</button>';
        var continueBtn = (0, _utils.safeGetElementById)('bwa-continue-btn');
        if (continueBtn) {
          continueBtn.onclick = function () {
            (0, _urlSafety.safeRedirect)(targetUrl);
          };
        }
      }
    }
  }, {
    key: "dismissBwALoader",
    value: function dismissBwALoader() {
      var _safeGetElementById, _safeGetElementById2;
      (_safeGetElementById = (0, _utils.safeGetElementById)('bwa-overlay')) === null || _safeGetElementById === void 0 || _safeGetElementById.remove();
      (_safeGetElementById2 = (0, _utils.safeGetElementById)('bwa-loader')) === null || _safeGetElementById2 === void 0 || _safeGetElementById2.remove();
      document.body.classList.remove('bwa-no-scroll');
    }
  }]);
}(_actionHandler["default"]);
//# sourceMappingURL=bwa-loader-render-handler.js.map
